import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { EventAvailable } from '@material-ui/icons';
import { Col, Container, Row, Button } from 'reactstrap';

import AlertModal from '../../../../shared/components/Modal';

const CantVisitsModal = ({ budget, CloseCantVisitsModal, opened, listVisits, originalCantVisit, setOriginalCantVisit, updateTotals }) => {

    //Alerta
    let lastCantVisit = originalCantVisit != null ? originalCantVisit : 0;

    const [cantVisit, setCantVisits] = React.useState(originalCantVisit != null ? originalCantVisit : 0);
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");
    const [openModal, setOpenModal] = React.useState(opened);

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const confirmVisits = () => {

        if(cantVisit < lastCantVisit)
        {
            alertModal(false,"Debe seleccionar un número Mayor de Visitas, si desea eliminar visitas, debe hacerlo manualmente");
            return;
        }


        setAlertColorModal("warning");
        setAlerShowModal(true);
        setAlertMessageModal("Esta Seguro que desea realizar los cambios en la cantidad de visitas?");
    }

    const updateVisitsCount = () => {
        setOriginalCantVisit(cantVisit);
        changeVisits();
    }

    const okModal = () => {
        switch (colorAlertModal) {
            case "warning":
                updateVisitsCount();
                break;
            default:
                setAlerShowModal(false);
                break;
        }
    }

    const changeVisits = async () => {
        fetch(`${process.env.REACT_APP_PUBLIC_URL}presupuesto/actualizar_cant_visitas`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_presupuesto: budget.id_presupuesto, cant_presupuesto: cantVisit })
        }).then(response => response.json()).then(data => {

            updateTotals(data.presupuesto.costo, data.presupuesto.valor_venta, data.presupuesto.presupuesto);

            listVisits(budget.id_factibilidad);
            CloseCantVisitsModal();
        }).catch(err => {
            console.log(err);
        });
    }

    const handleChangeCantVisits = (value) => {
        setCantVisits(value);
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    setOpenModal(false);
                    CloseCantVisitsModal(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000, width: '100%' }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>

                    <div>
                        <div className="card__title text-center">
                            <h5 className="bold-text">Agregar Cantidad de Visitas</h5>
                            <TextField
                                onChange={(event) => handleChangeCantVisits(event.target.value)}

                                style={{ minWidth: '200px', maxWidth: '200px' }}
                                label="Cantidad de Visitas"
                                type="number"
                                value={cantVisit}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Button
                                disabled={false}
                                style={{ marginTop: 10, marginRight: 10 }}
                                variant="contained"
                                className="btn btn-primary btn-sm text-white"
                                onClick={() => {
                                    confirmVisits();
                                }}
                            >
                                Confirmar
                            </Button>
                            <Button
                                style={{ marginTop: 10 }}
                                variant="contained"
                                className="btn btn-secondary btn-sm"
                                onClick={() => {
                                    setOpenModal(false);
                                    CloseCantVisitsModal(false);
                                }}
                            >
                                Cerrar
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => okModal()}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default CantVisitsModal;
